module.exports = __webpack_public_path__ + "static/media/eco-ecology-energy-svgrepo-com.5fb53caa.svg";